import { Inmueble } from '@app/models/inmueble';
import { createAction, props } from '@ngrx/store';
import { Data } from 'src/app/interfaces/home-response';
import { PolicyHolder } from 'src/app/models/policyHolder';
import { Tenant } from 'src/app/models/tenant';

export const loadData = createAction( //PRUEBAS
    '[Data] Load Data',
    props<{ body: any }>()
);

export const loadDataSuccess = createAction(
    '[Data] Load Data Success',
    props<{ data: any }>()
);

export const loadlead = createAction(
    '[Data] Load loadlead Success',
    props<{ body: any }>()
);
export const loadDataFailure = createAction(
    '[Data] Load Data Failure',
    props<{ error: any }>()
);

export const loadPolicyHolder = createAction(
    '[PolicyHolder] Load Policy Holder',
    props<{ PolicyHolder: PolicyHolder }>()
);

export const loadPolicyHolderSuccess = createAction(
    '[PolicyHolder] Load Policy Holder Success',
    props<{ PolicyHolder: PolicyHolder }>()
);

export const setData = createAction(
    '[General] Set Data',
    props<{ key: string, value: any, merge: boolean }>()
);
export const removeData = createAction(
    '[General] Remove Data',
    props<{ key: string }>()
);

export const loadTenant = createAction(
    '[General] Load Tenant',
    props<{ Tenant: any }>()
);

export const loadInmuebleData = createAction(
    '[InmuebleData] Load Inmueble Data',
    props<{ Inmueble: Inmueble }>()
);
